import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class SessionWidgetService {
    public getWidgetsApi: string = "/svcs/recommendation-integration/widgets";
    public sessionWidgetCommonApi: string = "/svcs/recommendation-integration/widget";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public getRecommendationWidgetsByUUID(eventUUID: string) {
        return this.http.get(this.getWidgetsApi, {
            params: new HttpParams().set("eventUUID", eventUUID),
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getRecommendationWidgetSnippetPreview(eventUUID: string, widgetUUID: string) {
        let snippetPreviewURL = this.sessionWidgetCommonApi+ "/" + widgetUUID + "/snippet-preview";

        return this.http.get(snippetPreviewURL, {
            params: new HttpParams().set("eventUUID", eventUUID),
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getRecommendationWidgetSnippet(eventUUID: string, widgetUUID: string) {
        let snippetURL = this.sessionWidgetCommonApi+ "/" + widgetUUID + "/snippet";

        const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
        return this.http.get(snippetURL, {
            params: new HttpParams().set("eventUUID", eventUUID),
            observe: "response",
            headers: headers,
            responseType: 'text'
        });
    }

    public getRecommendationWidgetSnippetConfiguration(eventUUID: string, widgetUUID: string) {
        let snippetConfigURL = this.sessionWidgetCommonApi+ "/" + widgetUUID + "/configuration";

        return this.http.get(snippetConfigURL, {
            params: new HttpParams().set("eventUUID", eventUUID),
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
